<template>
  <HomeworkStudentStatis></HomeworkStudentStatis>
</template>

<script>
import HomeworkStudentStatis from "@/components/Homework/HomeworkStudentStatis";
export default {
  name: "StudentHomeworkStatis",
  components: {
    HomeworkStudentStatis
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>